import { render, staticRenderFns } from "./DeleteUserDialog.vue?vue&type=template&id=8b81e70a"
import script from "./DeleteUserDialog.vue?vue&type=script&lang=js"
export * from "./DeleteUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports